import { useContext } from "react";
import { globalContext } from "../../global/Store";
import config from "../../config/Config.json";
import { GetMockMilestoneRead } from "../../mock/milestone/MilestoneRead";
import { GetMockMilestoneList } from "../../mock/milestone/MilestoneList";

export const useMilestoneDataRepo = () => {
  const { globalState, dispatch, globalFunctions } = useContext(globalContext);

  const GetMilestone = (id: number) => {
    return new Promise(function (resolve, reject) {
      if (config.RunMode === "MOCK") {
        resolve(GetMockMilestoneRead());
      } else {
        globalFunctions
          .CallPortalApi("Milestone/Read", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + globalState.user.token,
            },
            body: JSON.stringify({
              Id: id,
            }),
          })
          .then(
            function (response: any) {
              resolve(response);
            },
            function (error: any) {
              reject(error);
            }
          );
      }
    });
  };

  const GetMilestoneList = (id: number) => {
    return new Promise(function (resolve, reject) {
      if (config.RunMode === "MOCK") {
        resolve(GetMockMilestoneList());
      } else {
        globalFunctions
          .CallPortalApi("Milestone/List", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + globalState.user.token,
            },
            body: JSON.stringify({
              Id: id,
            }),
          })
          .then(
            function (response: any) {
              resolve(response);
            },
            function (error: any) {
              reject(error);
            }
          );
      }
    });
  };

  return { GetMilestone, GetMilestoneList };
};
